/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import type { LoginStore } from './login-store';

export const LoginContext = React.createContext<LoginStore>({} as LoginStore);
